import {ReactNode} from 'react';
import {Link} from 'react-router-dom';
import {ChevronDown} from 'lucide-react';
import {DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger} from "../ui/dropdown-menu";
import {TinctIcon} from "./tinct-icon";

export type FunnelDropdownOption = {
  label: ReactNode;
  icon?: ReactNode;
} & (
  | { onClick: () => void; to?: never }
  | { to: string; onClick?: never }
);

export type FunnelDropdownOptionsProps = {
  options: FunnelDropdownOption[];
  label?: string | null;
  triggerLabel?: string;
};

export function FunnelDropdownOptions({
  options,
  label,
  triggerLabel = 'Options',
}: FunnelDropdownOptionsProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex items-center gap-2 rounded-md border border-input bg-background px-4 py-2 shadow-xs"
        >
          <TinctIcon className="size-5" />
          <div className={'text-sm max-w-32 text-ellipsis overflow-hidden whitespace-nowrap'}>{label}</div>
          <ChevronDown className="size-4 opacity-50" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {options.map((option, index) => {
          if (option.to) {
            return (
              <DropdownMenuItem key={index} asChild>
                <Link to={option.to} className="flex items-center gap-2">
                  {option.icon}
                  {option.label}
                </Link>
              </DropdownMenuItem>
            );
          }

          return (
            <DropdownMenuItem
              key={index}
              onClick={option.onClick}
              className="flex items-center gap-2"
            >
              {option.icon}
              {option.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
